import { AiOutlineHome } from "react-icons/ai";
import { BsChevronDown } from "react-icons/bs";
import { MdOutlineMusicVideo } from "react-icons/md";
import { CiCircleCheck } from "react-icons/ci";
import { MdComputer } from "react-icons/md";
import { VscDebugConsole } from "react-icons/vsc";

export const URL = {
  home: "/",
  signin: "/signin",

  bailiff:'/bailiff',

  //kyc
  kyc: "/kyc",

  // vm
  vm: "/virtual-machine",

  // debug
  debugJob: "/debug-job",

  //bailiff
  bailiffDetail: "/bailiff/:bailiffId",
  segment: "/bailiff/:bailiffId/:slotId",

  //
  system: "system",
  dev: "/dev",
};

// -------------------------- ITEM MAPPING --------------------------
export const newItems = () => {
  const items = {
    home: {
      title: "Dashboard",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
      icon: <AiOutlineHome />,
    },
    dashboard: {
      title: "Danh sách bản ghi âm",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
      icon: <MdOutlineMusicVideo />,
    },
    kyc: {
      title: "Danh sách đơn xin kyc",
      url: URL.kyc,
      key: "2",
      hightlight: ["2"],
      require: [],
      arrow: false,
      icon: <CiCircleCheck />,
    },
    computer: {
      title: "Quản lý VM",
      url: URL.vm,
      key: "3",
      hightlight: ["3"],
      require: [],
      arrow: false,
      icon: <MdComputer />,
    },
    debug: {
      title: "Tạo Debug Job",
      url: URL.debugJob,
      key: "4",
      hightlight: ["4"],
      require: [],
      arrow: false,
      icon: <VscDebugConsole />,
    },
    login: {
      title: "Đăng nhập",
      url: URL.home,
      key: "1",
      hightlight: ["1"],
      require: [],
      arrow: false,
    },
  };
  return items;
};

// -------------------------- BREAD CRUMB --------------------------
// -------------------------- MENU --------------------------
export const setMenuItem = (props) => {
  if (props?.title) {
    const { title, url, key, arrow, icon, children } = props;
    const href = url;
    let label = href ? (
      <>
        <a href={href} target="_self" rel="noopener noreferrer">
          {title}
        </a>
        {arrow ? (
          <BsChevronDown
            style={{ fontSize: 10, marginLeft: 5 }}
            className="arrow-down"
          />
        ) : null}
      </>
    ) : (
      title
    );
    return { key, children, label, icon };
  }
  return null;
};

export const newMenus = (items) => {
  const menu = [
    setMenuItem({ ...items?.dashboard }),
    setMenuItem({ ...items?.computer }),
    setMenuItem({ ...items?.kyc }),
    setMenuItem({ ...items?.debug }),
  ];
  return menu;
};

export const newAuthMenu = (items, logged) => {
  const loggedin = [setMenuItem({ ...items?.account })];
  const anonymous = [
    setMenuItem({ ...items?.register }),
    setMenuItem({ ...items?.login }),
  ];
  const menu = logged === null ? [] : logged === true ? loggedin : anonymous;
  return menu;
};

export const newDashboard = (items) => {
  const operator = [items?.operators];
  const concepts = [items?.concepts, items?.approves];
  const news = [items?.newsCategory, items?.newsPost];
  const three = [items?.threeMapperListing, items?.threeMapperBrand];
  return {
    operator,
    concepts,
    news,
    three,
  };
};
